import { createAsyncThunk } from '@reduxjs/toolkit';
import { uniq } from 'lodash';
import {
  selectUserActiveEmployerBusinessId,
  selectUserActiveEmployerInfo,
} from 'store/user/selectors.js/user.selectors';
import { getShadowRecordsByIds } from '../services/getShadowRecordsByIds.service';

export const loadShadowRecordsForRecords = createAsyncThunk(
  'shadowData/loadShadowRecordsForRecords',
  async (recordIds, { getState }) => {
    const state = getState();
    const activeEmployerBusinessId = selectUserActiveEmployerBusinessId(state);
    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    if (!activeEmployerBusinessId || !recordIds || recordIds.length === 0) {
      return [];
    }

    const uniqueRecordIds = uniq(recordIds);
    const shadowRecordIds = uniqueRecordIds.map(
      (recordId) => `${recordId}_${activeEmployerBusinessId}`
    );

    const shadowRecords = await getShadowRecordsByIds(
      shadowRecordIds,
      activeEmployerInfo
    );

    return shadowRecords;
  }
);
